export const heroData = {
    introText: "",
    highlightedText: "",
    title: "Building Pathways to Justice Across Communities and Borders",
    subtitle: "Bridges of Justice is a New York–based nonprofit organization advancing justice, equity, and human dignity.",
    btnText: "Get Involved",
    btnLink: "/contact",
    backgroundImage: "/img/hero-bg-2.png"
};

// ...

export const projectsData = [
    {
        id: 1,
        title: "Justice Reform Initiative",
        categories: ["Advocacy", "Reform"],
        image: "/img/portfolio/legal-advocacy.png"
    },
    {
        id: 2,
        title: "Community Outreach",
        categories: ["Education"],
        image: "/img/portfolio/community-outreach.png"
    },
    {
        id: 3,
        title: "Legal Aid Clinic",
        categories: ["Support"],
        image: "/img/portfolio/detention-support.png"
    }
];

export const contactData = {
    address: "New York, USA",
    email: "info@bridgesofjustice.org",
    phone: "+1 (555) 123-4567", // Placeholder, user didn't provide specific phone
    socials: [
        { platform: "Twitter", url: "#" },
        { platform: "LinkedIn", url: "#" },
        { platform: "Facebook", url: "#" }
    ]
};

export const blogData = [
    {
        id: 1,
        title: "Navigating the Legal System",
        excerpt: "A guide for families facing legal challenges...",
        date: "Oct 24, 2025",
        image: "/img/blog/blog-1.jpg"
    },
    {
        id: 2,
        title: "The Importance of Civic Participation",
        excerpt: "How citizens can contribute to a fairer justice system...",
        date: "Nov 02, 2025",
        image: "/img/blog/blog-2.jpg"
    }
];

export const aboutData = {
    title: "About Us",
    description: "We are dedicated to bridging the gap between communities and justice.",
    vision: "A world where justice is accessible to everyone regardless of their background.",
    values: [
        { title: "Integrity", description: "We uphold the highest standards of honesty and ethics." },
        { title: "Compassion", description: "We approach every case with empathy and understanding." },
        { title: "Excellence", description: "We strive for superior results in all our endeavors." }
    ]
};

export const servicesData = [
    { id: 1, title: "Legal Representation", description: "Providing expert legal counsel for individuals and organizations." },
    { id: 2, title: "Community Education", description: "Workshops and seminars to empower citizens with legal knowledge." },
    { id: 3, title: "Policy Advocacy", description: "Working to reform laws and policies for a fairer society." }
];

export const teamData = [
    { id: 1, name: "Sarah Johnson", role: "Executive Director", description: "Leading with over 15 years of experience in human rights law." },
    { id: 2, name: "David Chen", role: "Senior Attorney", description: "Specializing in civil litigation and public interest law." },
    { id: 3, name: "Maria Garcia", role: "Community Outreach Lead", description: "Connecting our services with the people who need them most." }
];
